import { atom } from 'jotai';

export interface DeviationTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  sourceLayerId: string;
  sourceLayerName: string;
  /** Snapshot of layer IDs that were already derived from `sourceLayerId` at
   * the moment the user clicked Run. The "new layer" produced by this run is
   * any layer with `metadata.derivedFrom === sourceLayerId` whose ID is NOT
   * in this snapshot. We previously compared `layer.createdAt` (server clock)
   * to a `Date.now()` captured client-side, which fails under any clock skew
   * — toast would either spin forever (client ahead of server) or resolve
   * immediately by matching a stale pre-existing derived layer (client behind). */
  existingDerivedLayerIds: string[];
}

export const deviationTrackingAtom = atom<DeviationTracker[]>([]);
